<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
  <div class="menu-board">
    <!-- 头部区域（参考 todayMenu.vue 的 .board-header 结构，无今日推荐） -->
    <header class="header">
      <!-- 左侧标题 -->
      <div class="title-area">
        <img
          class="title-image"
          src="https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260821/e4145c7375d55cfe4f4e41a7ec1a6083.jpg"
          alt="今日菜单标题"
          title="点击全屏"
          @click="handleFullScreen"
        />
        <div class="date-tag">{{ currentDate }}</div>
      </div>

      <!-- 中间档口 / 餐次信息（上下结构，档口名可能较长） -->
      <div class="header-center">
        <div class="stall-name" :title="stallName">{{ stallName }}</div>
        <div class="meal-tag" v-if="mealName">
          <span class="meal-name">{{ mealName }}</span>
        </div>
      </div>

      <!-- 右侧餐厅信息（可能没有，但始终占位保持三区布局稳定） -->
      <div class="header-right">
        <div class="restaurant-info" v-if="restaurantInfo">
          <div class="restaurant-icon">
            <i class="el-icon-office-building"></i>
          </div>
          <div class="restaurant-text">
            <div class="restaurant-name">{{ restaurantInfo }}</div>
            <div class="restaurant-sub">餐厅信息</div>
          </div>
        </div>
      </div>
    </header>

    <!-- 菜品卡片区（每页最多 2 张，多于 2 个自动轮播，单个自动撑开） -->
    <transition name="fade" mode="out-in">
      <div class="main-content" :key="page">
        <div
          class="food-card"
          :class="{ single: visibleItems.length === 1, 'sold-out': item.sold_out === 1 }"
          v-for="(item, index) in visibleItems"
          :key="item.id"
        >
        <!-- 编号（左上角） -->
        <div class="card-index">{{ String(index + 1).padStart(2, '0') }}</div>

        <!-- 卡片主体：左图右文 -->
        <div class="card-body">
          <div class="card-image">
            <img :src="item.image || defaultImage" :alt="item.name" />
            <!-- 图片提示：仅供参考 -->
            <div class="img-tip">图片仅供参考，实际以出餐为主</div>
          </div>
          <div class="card-info">
            <!-- 售罄徽标（card-info 右上角） -->
            <div class="sold-out-badge" v-if="item.sold_out === 1">售罄</div>
            <div class="food-name">{{ item.name }}</div>
            <div class="food-price">
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ item.price }}</span>
              <span class="price-unit">/份</span>
            </div>
          </div>
        </div>

        <!-- 库存信息区 -->
        <div class="card-inventory">
          <div class="inventory-item">
            <div class="inventory-label">总数量</div>
            <div class="inventory-value green">{{ item.total }}<span class="inventory-unit">份</span></div>
          </div>
          <div class="inventory-item">
            <div class="inventory-label">剩余数量</div>
            <div class="inventory-value orange">{{ item.remaining }}<span class="inventory-unit">份</span></div>
          </div>
        </div>
      </div>
      </div>
    </transition>

    <!-- 底部信息栏 -->
    <div class="footer">
      <div class="footer-left">
        <img src="../assets/image/wenxin.png" style="width: 15px;margin-right: 10px;">
        <span>温馨提示：请按需取餐，珍惜粮食，杜绝浪费</span>
      </div>
      <!-- <div class="footer-right">
        <i class="el-icon-time"></i>
        <span>营业时间：10:30 - 20:30</span>
      </div> -->
    </div>
  </div>
  </v-scale-screen>
</template>

<script>
import { getTodayDishes } from "../api/api";
export default {
  name: "MenuBoard",
  data() {
    return {
      // 档口名称（默认"2号档口"，后端 stall_name 有值时覆盖）
      stallName: "2号档口",
      // 餐次名称（后端 meal_name 有值时展示）
      mealName: "",
      // 餐厅信息（后端有值则展示在 header 右侧，无值则区域空占位）
      restaurantInfo: "",
      // 是否处于全屏状态（点击标题图片切换）
      fullscreen: false,
      // 默认图片：菜品 image 为空时兜底
      defaultImage:
        "https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260819/ec502ef7265a0998b3672eab19618627.png",
      currentDate: "",
      currentTime: "",
      timer: null,
      carouselTimer: null,
      // 数据定时刷新定时器（每 10 秒）
      refreshTimer: null,
      // 每页最多展示的菜品数
      perPage: 2,
      // 当前页（从 0 开始）
      page: 0,
      foodList: [],
    };
  },
  computed: {
    // 总页数（每页最多 2 个菜品）
    totalPages() {
      return Math.ceil(this.foodList.length / this.perPage) || 1;
    },
    // 当前页展示的菜品
    visibleItems() {
      const start = this.page * this.perPage;
      return this.foodList.slice(start, start + this.perPage);
    },
  },
  mounted() {
    this.getTodayDishes()
    this.updateDateTime();
    this.timer = setInterval(this.updateDateTime, 5000);
    // 每 10 秒轮询一次最新数据，保证售罄状态 / 剩余数量实时刷新
    this.refreshTimer = setInterval(() => {
      this.getTodayDishes();
    }, 10000);
    this.startCarousel();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
    this.stopCarousel();
  },
  methods: {    
    // 点击标题图片进入 / 退出全屏
    handleFullScreen() {
      const element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },

    // 从当前页面 URL 解析 query 参数（不依赖 vue-router）
    parseUrlParams() {
      const params = {};
      const search = window.location.search;
      if (!search) return params;
      const pairs = search.substring(1).split('&');
      pairs.forEach((pair) => {
        if (!pair) return;
        const [key, value] = pair.split('=');
        if (key) {
          params[decodeURIComponent(key)] = value
            ? decodeURIComponent(value)
            : '';
        }
      });
      return params;
    },
    async getTodayDishes() {
      const query = this.parseUrlParams();
      const params = {
        shop_id: query.shop_id,
        date: query.date || null,
        stall_name: query.stall_name,
        meal_name: query.meal_name
      };
      try {
        const res = await getTodayDishes(params);
        console.log(res, 'getTodayDishes');
        // 后端业务数据体（axios 的 res.data 为后端 JSON，业务字段在其 data 下）
        const biz = res && res.data && res.data.data;
        if (!biz) return;

        // 档口名称：后端 stall_name 没有值或为空时保留默认值
        if (biz.stall_name && biz.stall_name.trim()) {
          this.stallName = biz.stall_name.trim();
        }

        // 餐次名称：后端 meal_name 有值时展示
        if (biz.meal_name && biz.meal_name.trim()) {
          this.mealName = biz.meal_name.trim();
        }

        // 餐厅信息：优先取 restaurant_name / dining_name / shop_name，无则空占位
        const restName =
          biz.restaurant_name || biz.dining_name || biz.shop_name;
        if (restName && String(restName).trim()) {
          this.restaurantInfo = String(restName).trim();
        }

        // 后端菜品数组 dishes（每项 { dish_name, image, initial_quantity, price,
        // remaining_quantity, sold_out, sold_quantity, stock_record_id }）
        // 映射为页面使用的 foodList 结构
        const dishes = biz.dishes;
        if (Array.isArray(dishes) && dishes.length) {
          // 增量更新：图片 / 名称 / 价格 / 总数量保持不变，
          // 仅在有变化时更新剩余数量与售罄状态，避免整表替换导致画面闪烁空白
          const newList = [];
          let changed = false;
          dishes.forEach((d, index) => {
            const name = d.dish_name || d.name || '未知菜品';
            const remaining =
              d.remaining_quantity != null ? d.remaining_quantity : 0;
            // 剩余数量为 0 时按售罄处理
            const soldOut = d.sold_out === 1 || remaining === 0;
            // 按菜名匹配已存在的项，复用其原有数据（图片、名称等保持不动）
            const exist = this.foodList.find((f) => f.name === name);
            if (exist) {
              const next = { ...exist };
              // 剩余数量或售罄状态有变化才更新对应字段
              if (next.remaining !== remaining) {
                next.remaining = remaining;
                changed = true;
              }
              if (next.sold_out !== soldOut) {
                next.sold_out = soldOut;
                changed = true;
              }
              newList.push(next);
            } else {
              // 新菜品：完整构建
              newList.push({
                id: `${index}_${d.stock_record_id != null ? d.stock_record_id : ''}`,
                name,
                price: d.price != null ? d.price : '0',
                total: d.initial_quantity != null ? d.initial_quantity : 0,
                remaining,
                image: d.image || '',
                sold_out: soldOut,
                sold_quantity: d.sold_quantity != null ? d.sold_quantity : 0
              });
              changed = true;
            }
          });
          // 没有任何变化时保持原 foodList 引用，不做重渲染，避免闪烁
          if (changed || newList.length !== this.foodList.length) {
            this.foodList = newList;
            // 数据刷新时保留当前轮播页；若菜品减少导致页号越界则取最后一页
            const maxPage = Math.ceil(newList.length / this.perPage) - 1;
            if (this.page > maxPage) {
              this.page = maxPage;
            }
            // 数据更新后按条数重新决定是否轮播
            this.startCarousel();
          }
        }
        // 接口无菜品时保留现有展示，不置空列表，避免空白画面
      } catch (e) {
        // 请求失败时保留页面内置的 mock 数据兜底
        console.error('获取今日菜品失败：', e);
      }
    },
    // 开启菜品自动轮播（多于 2 个时每 5 秒切换一页）
    startCarousel() {
      this.stopCarousel();
      if (this.totalPages > 1) {
        this.carouselTimer = setInterval(() => {
          this.page = (this.page + 1) % this.totalPages;
        }, 5000);
      }
    },
    // 停止轮播
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    updateDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const weekDays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      const weekDay = weekDays[now.getDay()];
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      this.currentDate = `${year}-${month}-${day} ${weekDay}`;
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style scoped>
/* ==================== 基础重置 ==================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.menu-board {
  width: 1920px;
  height: 1080px;
  background-color: #155730;
  display: flex;
  flex-direction: column;
  font-family: "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial,
    sans-serif;
  color: #ffffff;
  overflow: hidden;
}

/* ==================== 背景装饰 ==================== */
.menu-board::before {
  content: "";
  position: absolute;
  top: -80px;
  right: -100px;
  width: 600px;
  height: 600px;
  background: radial-gradient(
    circle,
    rgba(45, 130, 70, 0.5) 0%,
    transparent 70%
  );
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

.menu-board::after {
  content: "";
  position: absolute;
  bottom: -150px;
  right: 100px;
  width: 500px;
  height: 500px;
  background: radial-gradient(
    circle,
    rgba(30, 100, 55, 0.4) 0%,
    transparent 70%
  );
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

/* ==================== 头部区域（参考 todayMenu.vue 的 .board-header 结构） ==================== */
.header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 48px 20px;
  flex-shrink: 0;
}

/* 左侧标题区 */
.title-area {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.title-image {
  width: 360px;
  height: 180px;
  display: block;
  cursor: pointer;
}

.date-tag {
  margin-top: 12px;
  margin-left: 16px;
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}

/* 中间档口 / 餐次信息（上下结构，档口名可能较长） */
.header-center {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 40px;
}

.stall-name {
  font-size: 84px;
  font-weight: 900;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: 3px;
  text-align: center;
  line-height: 1.3;
  max-width: 100%;
  word-break: break-all;
}

.meal-tag {
  display: inline-flex;
  align-items: center;
  background: #FACF5C;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #4E1A04;
  font-size: 36px;
  font-weight: 600;
  padding: 4px 22px;
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}

/* 右侧餐厅信息区：与左侧标题区等宽占位，保证三区对称；无内容时也不塌陷 */
.header-right {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.restaurant-info {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  padding: 12px 22px;
  max-width: 100%;
}

.restaurant-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #FACF5C;
  font-size: 24px;
  color: #4E1A04;
}

.restaurant-text {
  min-width: 0;
}

.restaurant-name {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.restaurant-sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 2px;
}

/* ==================== 主内容区（卡片收窄居中，不再撑满整屏） ==================== */
.main-content {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 0 48px;
}

/* ==================== 菜品卡片（等比放大 1.5 倍） ==================== */
.food-card {
  flex: 0 1 930px;
  min-width: 0;
  min-height: 640px;
  background-color: #ffffff;
  border-radius: 30px;
  padding: 33px 19px 36px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  color: #1a1a1a;
}

/* 单个菜品时卡片自动撑开占满 */
.food-card.single {
  flex: 1;
}

/* 单菜品时内容左对齐，避免居中显得空旷 */
.food-card.single .card-body {
  justify-content: flex-start;
  padding-left: 40px;
}

/* 轮播切换淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 编号标签 */
.card-index {
  position: absolute;
  top: 30px;
  left: 36px;
  background-color: #155730;
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  padding: 9px 24px;
  border-radius: 15px;
  line-height: 1;
  z-index: 2;
}

/* 卡片主体：左图右文（等比放大 1.5 倍，撑满中间区域使卡片更高更饱满） */
.card-body {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 36px;
  /* 顶部预留空间，避免被左上角编号 / 右上角售罄徽标遮挡 */
  padding-top: 40px;
}

.card-image {
  width: 280px;
  height: 230px;
  border-radius: 18px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f8f8f5;
  border: 1px solid #eef0ea;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 图片底部提示条 */
.img-tip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  /* background: linear-gradient(to top, rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.12)); */
  color: #E8752A;
  font-size: 18px;
  line-height: 1.4;
  text-align: center;
  padding: 8px 4px;
}

/* 售罄徽标：card-info 右上角（竖排印章样式） */
.sold-out-badge {
  position: absolute;
  top: -20px;
  right: -6px;
  z-index: 3;
  writing-mode: vertical-rl;
  text-orientation: upright;
  font-size: 90px;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: 8px;
  color: #ffffff;
  background: linear-gradient(180deg, #ff5a3c 0%, #e43c2a 100%);
  border: 3px solid rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  padding: 16px 9px;
  box-shadow:
    0 10px 24px rgba(228, 60, 42, 0.45),
    inset 0 0 12px rgba(255, 255, 255, 0.15);
  transform: rotate(6deg);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.card-info {
  /* 固定宽度：菜名长短不影响整体布局，图片与文字位置保持稳定 */
  width: 500px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 21px;
  /* 售罄徽标定位基准 */
  position: relative;
}

.food-name {
  font-size: 80px;
  font-weight: 700;
  line-height: 1.5;
  color: #1a1a1a;
  /* letter-spacing: 1.5px; */
  /* 固定为两行高度：菜名长短不同也不影响卡片高度 */
  min-height: 2em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.food-price {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.price-symbol {
  font-size: 40px;
  font-weight: 700;
  color: #e85d2a;
}

.price-value {
  font-size: 92px;
  font-weight: 800;
  color: #e85d2a;
  line-height: 1;
  letter-spacing: -1px;
}

.price-unit {
  font-size: 24px;
  color: #999999;
  margin-left: 6px;
}

/* ==================== 库存信息区 ==================== */
.card-inventory {
  display: flex;
  background-color: #f1f5f3;
  border-radius: 21px;
  padding: 30px 0 24px;
  box-shadow: inset 0 3px 12px rgba(21, 87, 48, 0.06);
}

.inventory-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.inventory-item:first-child {
  border-right: 1px solid #e0e7e2;
}

.inventory-label {
  font-size: 36px;
  font-weight: 700;
  color: #4a5a50;
  letter-spacing: 3px;
}

.inventory-value {
  font-size: 130px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -1px;
}

.inventory-value.green {
  color: #155730;
}

.inventory-value.orange {
  color: #e8752a;
}

.inventory-unit {
  font-size: 31px;
  color: #333333;
  margin-left: 12px;
}

/* ==================== 底部信息栏 ==================== */
.footer {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 48px 32px;
  flex-shrink: 0;
}

.footer-left,
.footer-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.85);
}

.footer-left .el-icon-volume-up,
.footer-right .el-icon-time {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.9);
}

/* ==================== 适配说明 ==================== */
/* 页面固定以 1920x1080 设计稿渲染，由外层 v-scale-screen 组件自动等比缩放适配各分辨率屏幕 */
</style>